import api from "./axios";

const EndPoints = {
  allUsers(
    page: number,
    filterData: { status: string; from: string; to: string; search: string },
    search: string
  ) {
    let query = `/merchant/business/customer?order=DESC&page=${page}&take=10`;
    if (search !== "") {
      query += `&search=${search}`;
    }
    if (filterData?.search !== "") {
      query += `&search=${filterData?.search}`;
    }
    if (filterData?.status !== "") {
      query += `&status=${filterData?.status}`;
    }
    if (filterData?.from !== "") {
      query += `&from=${filterData?.from}`;
    }
    if (filterData?.to !== "") {
      query += `&to=${filterData?.to}`;
    }
    return query;
  },
  allUsers2: `/merchant/business/customer?order=DESC&page=1&take=50`,
  search(search: string) {
    return `/merchant/business/customer?search=${search}`;
  },
  referral(page: number, filterData: { search: string }, id: string) {
    let query = `/merchant/business/customer/${id}/referrals?order=DESC&page=${page}&take=10`;

    if (filterData?.search !== "") {
      query += `&search=${filterData?.search}`;
    }
    return query;
  },
  user(id: string) {
    return `/merchant/business/customer/${id}`;
  },
  userActivities(page: number, id: string) {
    let query = `/merchant/activity?merchantId=${id}&order=DESC&page=${page}&take=10`;

    return query;
  },
  userSession(page: number) {
    return `/merchant/sessions?order=DESC&page=${page}&take=10`;
  },
  terminate(id: string) {
    return `/merchant/sessions/${id}`;
  },
  bank(id: string) {
    return `/merchant/business/customer/${id}/banks`;
  },
  transaction(page: number, id: string) {
    return `/merchant/transactions?order=DESC&page=${page}&take=10&customerId=${id}`;
  },
  count(id: string) {
    return `merchant/summary/transactions?math=count&customerId=${id}`;
  },
  volume(id: string) {
    return `merchant/summary/transactions?math=sum&customerId=${id}`;
  },
  allTransaction(page: number, id: string) {
    return `/merchant/transactions?order=DESC&page=${page}&take=10&customerId=${id}`;
  },
  suspend(id: string) {
    return `/merchant/business/customer/${id}/suspend`;
  },
  unsuspend(id: string) {
    return `/merchant/business/customer/${id}/unsuspend`;
  },
  loginLimit: `/merchant/business/customer/clear-login-attempt`,
  verify(id: string) {
    return `/merchant/business/customer/${id}/verify-email`;
  },
  exemptBanks(id: string) {
    return `/merchant/business/customer/${id}/exempt-banks-kyc`;
  },
  requireBanks(id: string) {
    return `/merchant/business/customer/${id}/require-banks-kyc`;
  },
  exemptBank(id: string) {
    return `/merchant/bank/${id}/exempt-kyc`;
  },
  requireBank(id: string) {
    return `/merchant/bank/${id}/require-kyc`;
  },
  suspendPayout(id: string) {
    return `/merchant/business/customer/${id}/suspend-payout`;
  },
  unsuspendPayout(id: string) {
    return `/merchant/business/customer/${id}/unsuspend-payout`;
  },

  download(
    to: string,
    from: string,
    path: string,
    status: string,
    emailVerified: string,
    kycStatus: string
  ) {
    let query = `/merchant/${path}?action=export`;
    if (to !== "") {
      query += `&to=${to}`;
    }

    if (from !== "") {
      query += `&from=${from}`;
    }
    // if (kycStatus !== "") {
    //   query += `&kycStatus=${kycStatus}`;
    // }
    if (status !== "") {
      query += `&${
        ["true", "false"].includes(status)
          ? "emailVerified"
          : ["active", "inactive"]?.includes(status)
          ? "status"
          : "kycStatus"
      }=${status}`;
    }
    // if (emailVerified !== "") {
    //   query += `&emailVerified=${emailVerified}`;
    // }

    // if (to !== "" && from !== "") {
    //   query += `?to=${to}&from=${from}&action=export`;
    // } else if (to !== "" && from !== "" && status !== "") {
    //   query += `?to=${to}&from=${from}&status=${status}&action=export`;
    // } else {
    //   query += `?action=export`;
    // }
    return query;
  },
};

export const getUserByName = async (search: string) => {
  const res = await api.get(EndPoints.search(search));
  return res;
};
export const getAllUser = async (
  page: number,
  filterData: {
    from: string;
    search: string;
    to: string;
    status: string;
  },
  search: string
) => {
  const res = await api.get(EndPoints.allUsers(page, filterData, search));
  return res;
};
export const getAllUser2 = async () => {
  const res = await api.get(EndPoints.allUsers2);
  return res;
};
export const getAllUserReferral = async (
  page: number,
  filterData: { search: string },
  id: string
) => {
  const res = await api.get(EndPoints.referral(page, filterData, id));
  return res;
};
export const getUser = async (id: string) => {
  const res = await api.get(EndPoints.user(id));
  return res;
};
export const getUserActivities = async (page: number, id: string) => {
  const res = await api.get(EndPoints.userActivities(page, id));
  return res;
};
export const getUserSession = async (page: number) => {
  const res = await api.get(EndPoints.userSession(page));
  return res;
};

export const terminateSession = async (id: string) => {
  const res = await api.delete(EndPoints.terminate(id));
  return res;
};
export const getUserBank = async (id: string) => {
  const res = await api.get(EndPoints.bank(id));
  return res;
};
export const getUserTransactions = async (page: number, id: string) => {
  const res = await api.get(EndPoints.transaction(page, id));
  return res;
};
export const getUserTransactionsCount = async (id: string) => {
  const res = await api.get(EndPoints.count(id));
  return res;
};
export const getUserTransactionsVolume = async (id: string) => {
  const res = await api.get(EndPoints.volume(id));
  return res;
};
export const getAllUserTransactions = async (page: number, id: string) => {
  const res = await api.get(EndPoints.allTransaction(page, id));
  return res;
};

export const suspendUser = async (id: string, payload: unknown) => {
  const res = await api.patch(EndPoints.suspend(id), payload);
  return res;
};
export const unSuspendUser = async (id: string, payload: unknown) => {
  const res = await api.patch(EndPoints.unsuspend(id), payload);
  return res;
};
export const clearUserLoginLimit = async (payload: unknown) => {
  const res = await api.post(EndPoints.loginLimit, payload);
  return res;
};
export const verifyEmail = async (id: string) => {
  const res = await api.patch(EndPoints.verify(id));
  return res;
};
export const SuspendPayout = async (id: string) => {
  const res = await api.patch(EndPoints.suspendPayout(id));
  return res;
};
export const unSuspendPayout = async (id: string) => {
  const res = await api.patch(EndPoints.unsuspendPayout(id));
  return res;
};
export const RequireBanks = async (id: string) => {
  const res = await api.patch(EndPoints.requireBanks(id));
  return res;
};
export const ExemptBanks = async (id: string) => {
  const res = await api.patch(EndPoints.exemptBanks(id));
  return res;
};
export const RequireBank = async (id: string) => {
  const res = await api.patch(EndPoints.requireBank(id));
  return res;
};
export const ExemptBank = async (id: string) => {
  const res = await api.patch(EndPoints.exemptBank(id));
  return res;
};

export const getDownload = async (
  to: string,
  from: string,
  path: string,
  status: string,
  emailVerified: string,
  kycStatus: string
) => {
  const res = await api.get(
    EndPoints.download(to, from, path, status, emailVerified, kycStatus)
  );
  return res;
};
